import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Dialog, colors, Text } from '@spaceshipapp/cambridge';
import Button from '../../../components/Button';
import * as LocalStorage from '../../../utils/localStorage';
import { buttonStyle, Container, ImgContainer, modalStyle, SubText, textStyle } from './styled';
import Trans from 'next-translate/Trans';
import Link from '../../../components/Link';

export const LOCAL_STORAGE_KEY_IP = 'dismissIpRedirection';
export const availableCountryList = ['TW'];

interface Props {
  onClose(): void;
  countryCode?: string;
}

const RegionRedirection: React.FC<Props> = ({ onClose, countryCode }) => {
  const { t } = useTranslation('common');
  const ENV = process.env.NEXT_PUBLIC_ENV || 'development';
  const redirectingURL =
    ENV === 'production'
      ? `https://${countryCode?.toLocaleLowerCase()}.spaceshipapp.com/`
      : ` https://${countryCode?.toLocaleLowerCase()}.sship.dev/`;

  const handleCancel = () => {
    LocalStorage.saveItem(LOCAL_STORAGE_KEY_IP, 'true');
    onClose();
  };

  return (
    <Dialog
      eslint-disable-next-line
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      style={{
        display: 'flex',
        alignItems: 'center',
        minWidth: '24rem',
        padding: '1.5rem 2rem 2.5rem',
      }}
      title={t(`IpRedirection_${countryCode}.title`)}
      className={modalStyle}
    >
      <Container>
        <Trans
          i18nKey={`common:IpRedirection_${countryCode}.subtitle`}
          /* eslint-disable react/jsx-key */
          components={[<Text className={textStyle} />, <SubText />]}
        />
        <ImgContainer>
          <img
            src={`/ip/ip_image_${countryCode}@1x.png`}
            srcSet={`/ip/ip_image_${countryCode}@1x.png 1x, /ip/ip_image_${countryCode}@2x.png 2x`}
            alt={t(`IpRedirection_${countryCode}.logo`)}
          />
        </ImgContainer>

        <Button
          className={buttonStyle}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          as={Link}
          target="_self"
          variant="primary"
          size="sm"
          data-tracking-label={t(`commonEn:IpRedirection_${countryCode}.buttonAgree`)}
          href={redirectingURL}
        >
          {t(`IpRedirection_${countryCode}.buttonAgree`)}
        </Button>
        <Button
          onClick={handleCancel}
          style={{ textDecoration: 'none', padding: '0', color: `${colors.subtext}` }}
          variant="link"
          size="sm"
        >
          {t(`IpRedirection_${countryCode}.cancel`)}
        </Button>
      </Container>
    </Dialog>
  );
};

export default RegionRedirection;
